import { RootScopeEvents } from './../../../../common/services/root-scope-types';
import { AbstractRealtimeComponent } from '../../abstract-realtime-component';
export default class ScreensharePatientRealtimeComponent extends AbstractRealtimeComponent {
    /* @ngInject */
    constructor(patientScreensharePopup, trackingFactory, globalUi, VideoProviderFactory, patientRealtimeActions, $rootScope, screenshareFactory) {
        super();
        this.patientScreensharePopup = patientScreensharePopup;
        this.trackingFactory = trackingFactory;
        this.globalUi = globalUi;
        this.VideoProviderFactory = VideoProviderFactory;
        this.patientRealtimeActions = patientRealtimeActions;
        this.$rootScope = $rootScope;
        this.screenshareFactory = screenshareFactory;
        $rootScope.$on('screenshareStopped', () => {
            this.reset();
        });
        $rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SCREEN_SHARE_STARTED, (_e, { withAudio }) => {
            this.onSuccess(this.doctor, withAudio);
        });
        $rootScope.$on('otScreenPublisher:error', (_event, error) => {
            this.onScreenPublisherError(error);
            screenshareFactory.handleError(error);
        });
    }
    create({ activeComponents: any, }) {
        return this;
    }
    onLeave(person) {
        if (!this.doctor)
            return; // if already destroyed
        if (!this.doctor.isEqualTo(person))
            return;
        this.reset();
    }
    reset() {
        if (this.globalUi.ui.isRestartingCall)
            return;
        if (this.doctor) {
            this.stopScreensharing(this.doctor);
        }
        this.doctor = null;
        this.patientScreensharePopup.hide();
    }
    onMessage(message, person) {
        switch (message.action) {
            case 'screenshareRequest': {
                this.onScreenshareRequest(person);
                break;
            }
        }
    }
    onScreenshareRequest(doctor) {
        this.doctor = doctor;
        if (!this.globalUi.ui.screenSharing &&
            this.patientScreensharePopup.isOpen()) {
            this.reset();
            return;
        }
        this.patientScreensharePopup.open({
            ui: this.globalUi.ui,
            doctor: doctor,
            onClose: () => {
                if (!this.globalUi.ui.screenSharing) {
                    this.reset();
                }
            },
            startScreensharing: () => {
                this.startScreensharing(doctor);
            },
            stopScreensharing: () => {
                this.reset();
            },
        });
    }
    stopScreensharing(doctor) {
        this.globalUi.ui.screenSharing = false;
        this.patientRealtimeActions.sendToTarget(doctor, {
            action: 'screenshareStopped',
            componentName: 'screenshare',
        });
    }
    startScreensharing(doctor) {
        this.VideoProviderFactory.activeProvider
            .toggleScreenSharing()
            .then(() => {
            this.$rootScope.$applyAsync(() => {
                this.globalUi.ui.screenSharing = true;
            });
        })
            .catch((screenshareSettings) => {
            this.onError(doctor, screenshareSettings);
        });
    }
    onError(doctor, patientSettings) {
        this.patientRealtimeActions.sendToTarget(doctor, {
            action: 'screenshareError',
            componentName: 'screenshare',
            content: {
                screenshareSettings: patientSettings,
            },
        });
    }
    onSuccess(doctor, withAudio) {
        this.patientRealtimeActions.sendToTarget(doctor, {
            action: 'screenshareSuccess',
            componentName: 'screenshare',
            content: {
                withAudio,
            },
        });
    }
    onScreenPublisherError(error) {
        this.patientRealtimeActions.sendToTarget(this.doctor, {
            action: 'screenshareError',
            componentName: 'screenshare',
            content: {
                screenshareSettings: {},
            },
        });
    }
}
